'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal } from '@common/components';
import { cn } from '@core/utils';
import type { ReactNode } from 'react';
import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';
import { useBottomCTAAnimation } from './useBottomCTAAnimation';
export interface CartBottomCTABaseProps {
  children: ReactNode;
  toastContent?: ReactNode;
  isHidden?: boolean;
  className?: string;
}
export const CartBottomCTABase = t0 => {
  const $ = _c(19);
  const {
    children,
    toastContent,
    isHidden: t1,
    className
  } = t0;
  const isHidden = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isHidden || $[1] !== toastContent) {
    t2 = {
      isHidden,
      toastContent
    };
    $[0] = isHidden;
    $[1] = toastContent;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    isBottomVisible,
    isToastActive,
    displayToastContent
  } = useBottomCTAAnimation(t2);
  const t3 = isBottomVisible ? "translate-y-0" : "translate-y-full";
  let t4;
  if ($[3] !== className || $[4] !== t3) {
    t4 = cn("fixed inset-x-0 bottom-0 z-20 transition-transform duration-300 ease-out", t3, className);
    $[3] = className;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = isToastActive ? "bottom-full translate-y-20" : "bottom-0";
  let t6;
  if ($[6] !== t5) {
    t6 = cn("absolute inset-x-0 -z-10 rounded-t-medium bg-Gray-black px-16 py-8 transition-all duration-300 ease-out flex-center", t5);
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== displayToastContent) {
    t7 = <div className="mb-20">{displayToastContent}</div>;
    $[8] = displayToastContent;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t6 || $[11] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== children) {
    t9 = <div className="rounded-t-medium bg-Gray-white pb-[calc(12px+var(--safe-area-bottom,0px))] shadow-[0px_-8px_30px_0px_rgba(255,255,255,0.25)]">{children}</div>;
    $[13] = children;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t4 || $[16] !== t8 || $[17] !== t9) {
    t10 = <Portal renderTo={getMainWrapperElement}><div className={t4}>{t8}{t9}</div></Portal>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};